import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import EasyButton from 'components/Easy/EasyButton'

import IconSinKilometraje from 'public/img/easy/IconSinKilometraje.svg'
import IconElPrecioLoPonesTu from 'public/img/easy/IconElPrecioLoPonesTu.svg'
import IconCarShine from 'public/img/easy/IconCarShine.svg'
import IconLoDejas from 'public/img/easy/IconLoDejas.svg'
import IconLaPublicidad from 'public/img/easy/IconLaPublicidad.svg'
import IconEncontramosComprador from 'public/img/easy/IconEncontramosComprador.svg'
import IconDamosCredito from 'public/img/easy/IconDamosCredito.svg'
import IconEncargamosRecibasTuPago from 'public/img/easy/IconEncargamosRecibasTuPago.svg'
import IconEvitaFraudes from 'public/img/easy/IconEvitaFraudes.svg'
import IconSinPlanForzoso from 'public/img/easy/IconSinPlanForzoso.svg'
import EasyCaracteristicsList from 'components/Easy/EasyCaracteristicsList'

import IconPromovemos from 'components/icons/easy/train-car-autorack.svg'
import IconImplementacion from 'components/icons/easy/timeline-check.svg'
import IconCheck from 'components/icons/easy/order-bool-ascending-variant.svg'
import IconDocs from 'components/icons/easy/archive-check 1.svg'

import EasyWhatsappLink from 'components/Easy/EasyWhatsappLink/EasyWhatsappLink'
import sx from './styles'

function WhySellYourCarWithEasy(props) {
  const {
    title = 'EASY_WHY_BUY_A_CAR_WITH_EASY',
    subtitle = 'EASY_HELP_YOU_TO_BUY',
    isEasyAgencias = false,
    showEasyAgencyData = false,
    onClickButton,
    onClickWhatsappButton,
    showWhatsappButton,
  } = props

  const data = [
    {
      id: 1,
      icon: <IconSinKilometraje
        width={56}
      />,
      description: 'EASY_NO_YEAR_LIMIT',
    },
    {
      id: 2,
      icon: <IconElPrecioLoPonesTu
        width={56}
      />,
      description: 'EASY_YOUR_PRICE',
    },
    {
      id: 3,
      icon: <IconCarShine
        width={56}
      />,
      description: 'EASY_TAKE_PICS',
    },
    {
      id: 4,
      icon: <IconLoDejas
        width={56}
      />,
      description: 'EASY_YOU_LEAVE_IT',
    },
    {
      id: 5,
      icon: <IconLaPublicidad
        width={56}
      />,
      description: 'EASY_ADVERTISING',
    },
    {
      id: 6,
      icon: <IconEncontramosComprador
        width={56}
      />,
      description: 'EASY_WE_FOUND_A_BUYER',
    },
    {
      id: 7,
      icon: <IconDamosCredito
        width={56}
      />,
      description: 'EASY_GIVE_CREDIT',
    },
    {
      id: 8,
      icon: <IconEncargamosRecibasTuPago
        width={56}
      />,
      description: 'EASY_YOUR_PAY',
    },
    {
      id: 9,
      icon: <IconEvitaFraudes
        width={56}
      />,
      description: 'EASY_AVOID_SCAMS',
    },
    {
      id: 10,
      icon: <IconSinPlanForzoso
        width={56}
      />,
      description: 'EASY_NO_FORCED_PLAN',
    },
  ]

  const easyAgenciasData = [
    {
      id: 1,
      icon: <IconPromovemos
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_1',
    },
    {
      id: 2,
      icon: <IconElPrecioLoPonesTu
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_2',
    },
    {
      id: 3,
      icon: <IconImplementacion
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_3',
    },
    {
      id: 4,
      icon: <IconCheck
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_4',
    },
    {
      id: 5,
      icon: <IconDocs
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_5',
    },
    {
      id: 6,
      icon: <IconLaPublicidad
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_6',
    },
    {
      id: 7,
      icon: <IconEncontramosComprador
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_7',
    },
    {
      id: 8,
      icon: <IconDamosCredito
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_8',
    },
    {
      id: 9,
      icon: <IconEncargamosRecibasTuPago
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_9',
    },
    {
      id: 10,
      icon: <IconEvitaFraudes
        width={56}
      />,
      description: 'EASY_AGENCIAS_FEATURED_10',
    },
  ]

  return (
    <Grid
      id="Porqueeasy"
      container
      sx={sx.root}
    >
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
        display="flex"
        container
        flexDirection="column"
        justifyContent="center"
        sx={sx.title}
      >
        <Typography
          component="h2"
          align="center"
          textAlign="center"
          variant="h1"
        >
          <FormattedMessage
            id={title}
          />
        </Typography>

        <Typography
          component="h3"
          sx={sx.subtitle}
          align="center"
          variant="h2"
          textAlign="center"
          mt={1}
        >
          <FormattedMessage id={subtitle} />
        </Typography>

      </Grid>

      <EasyCaracteristicsList data={showEasyAgencyData ? easyAgenciasData : data} />

      <Grid
        size={12}
        sx={sx.cts}
      >
        <EasyButton
          showIcon={!isEasyAgencias}
          cta={isEasyAgencias ? 'EASY_IM_INTERESTED' : 'EASY_MAIN_CTA'}
          handleClick={onClickButton}
        />
        {showWhatsappButton && (
          <EasyWhatsappLink onClickWhatsapp={onClickWhatsappButton} />
        )}
      </Grid>

    </Grid>
  )
}

export default memo(WhySellYourCarWithEasy)
